var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.409 2.5677L21.3085 2.47787C20.954 2.16226 20.4738 1.99092 19.9751 2.00037C19.4765 2.00868 19.0041 2.20008 18.6654 2.52873L8.43909 12.496L8.23802 12.5727L8.04225 12.4924L5.50505 9.84484C5.13744 9.46304 4.61086 9.23496 4.04748 9.2149C3.48385 9.19485 2.93635 9.38736 2.53824 9.74194C1.9033 10.3104 1.81993 11.2051 2.34246 11.8588L7.57664 18.4079C7.87422 18.7802 8.35443 19 8.86638 19H9.3227C10.1839 19 10.9894 18.6243 11.4775 17.9918L21.6416 4.87484C22.1974 4.15737 22.0968 3.1857 21.409 2.5677Z",
    fill: "#32D16D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.de4b9fabff25a41489410bd7fb8aa37d.svg";
export { ForwardRef as ReactComponent };